<template>
  <table class="table">
    <thead>
    <slot name="columns">
      <tr>
        <th :key="column" v-for="column in columns">{{column}}</th>

        <th v-if="hasActions()">Actions</th>
      </tr>
    </slot>
    </thead>
    <tbody>
    <tr :key="index" v-for="(item, index) in data">
      <slot :row="item">
        <td :key="column" v-for="column in columns" v-if="hasValue(item, column)">{{itemValue(item, column)}}</td>

        <td v-if="hasActions()">
          <font-awesome-icon style="margin-left: 10px" :icon="`${action.icon}`" v-for="action in actions"
                             v-on:click="handleAction(item, action.handler)"/>
        </td>
      </slot>
    </tr>
    </tbody>
  </table>
</template>
<script>
  import moment from 'moment-timezone';

  export default {
    name: 'l-table-params',
    props: {
      columns: Array,
      data: Array,
      mapName: Object,
      mapValue: Object,
      actions: Array,
    },
    methods: {
      hasValue(item, column) {
        return item[column.toLowerCase()] !== 'undefined'
      },
      itemValue(item, column) {
        let columnName;

        if (this.mapName && column in this.mapName) {
          columnName = this.mapName[column];
        } else {
          columnName = column.toLowerCase();
        }

        let value = item[columnName];

        if (this.mapValue && columnName in this.mapValue) {
          let tmp = this.mapValue[columnName];

          if(tmp !== null && value !== null) {
            if (tmp['divider']) {
              value = value / tmp['divider'];
            }

            if (tmp['type'] === 'double') {
              value = value.toFixed(tmp['fixed']);
            } else if (tmp['type'] === 'timestamp') {
              value = this.millisecondsToStr(value);
            } else if (tmp['type'] === 'direction') {
              if (value <= 23 || value > 336) {
                value = 'N';
              } else if ( value <= 68 ) {
                value = 'NE';
              } else if ( value <= 113 ) {
                value = 'E';
              } else if ( value <= 158 ) {
                value = 'SE';
              } else if ( value <= 203 ) {
                value = 'S';
              } else if ( value <= 248 ) {
                value = 'SW';
              } else if ( value <= 293 ) {
                value = 'W';
              } else if ( value <= 336 ) {
                value = 'NW';
              }
            }

            if (tmp['unit']) {
              value += ' ' + tmp['unit'];
            }
          }
        }

        return value;
      },
      hasActions() {
        return this.actions != null && this.actions.length > 0;
      },
      handleAction: (item,handler) => {
        handler(item);
      },
      millisecondsToStr(secs) {
        return moment(secs).tz("Europe/Warsaw").format('YYYY-MM-DD HH:mm:ss');
      }
    }
  }
</script>
<style>
</style>
